import React, {useEffect, useState, forwardRef} from 'react';
import videojs from 'video.js'
import "video.js/dist/video-js.css"
import _ from 'lodash'
import "./VideoJS.sass"

const VideoJS = forwardRef(({src, style, onReady, minimal}, playerRef) => {
    const videoRef = React.useRef(null);
    const [player, setPlayer] = useState(null)
    const props = {
        "controls": true,
        "controlBar":minimal?false:{
            "pictureInPictureToggle": false
        },
        "source": {
            "src": src
        },
        "sources": [
            {
                "src": src + "(format=m3u8-aapl)",
                "type": "application/x-mpegURL",
            },
            {
                "src": src + "(format=m3u8-cmaf)",
                "type": "application/x-mpegURL",
            },
            {
                "src": src + "(format=mpd-time-csf)",
                "type": "application/dash+xml",
            },
            {
                "src": src + "(format=mpd-time-cmaf)",
                "type": "application/dash+xml",
            },
        ]
    }

    useEffect(() => {
        console.log("VideoJS init useEffect()");
        if (!player) {
            const videoElement = videoRef.current;
            if (!videoElement) return;
            setPlayer((videojs(videoElement, props, () => {
                console.log("player is ready");
                onReady && onReady();
            })))
        } else {
            player.src(props.source);
        }
    }, [props, videoRef]);

    useEffect(() => {
        if(!playerRef) return
        const player = playerRef.current;
        return () => {
            if (player) {
                //the below throws an error
                //player.dispose();
                playerRef.current = null;
            }
        };
    }, [playerRef]);

    return (
        <div ref={playerRef}
             style={style || {}}
             data-vjs-player>
            <video ref={videoRef}
                   className="video-js vjs-big-play-centered"/>
        </div>
    );
})

export default VideoJS;